// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.4.0",
  date: "2026-07-30T09:33:39.533Z",
  gitInfo: {
    dirty: false,
    raw: "21e47abe2",
    hash: "21e47abe2",
    distance: null,
    tag: null,
    semver: null,
    suffix: "21e47abe2",
    semverString: null
  }
};
/* tslint:enable */
